<template>
  <div class="wrapper">
    <div class="main-panel d-none" id="adminBody">
      <div class="d-flex flex-column" style="min-height: 100vh">
        <!-- begin:: App Modal Info -->
        <AppModalInfo
          ref="AppModalInfo"
          :show="infoModal.show"
          :title="infoModal.title"
          :messages="infoModal.messages"
          :buttons="infoModal.buttons"
        ></AppModalInfo>
        <!-- end:: App Modal Info -->

        <Sidebar></Sidebar>
        <TopNavbar :subHeader="subHeader"></TopNavbar>
        <DashboardContent @click="toggleSidebar"> </DashboardContent>
        <content-footer></content-footer>
        <!-- begin:: App Loading -->
        <AppLoading></AppLoading>
        <!-- end:: App Loading -->
      </div>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import { mapGetters } from "vuex";
import TopNavbar from "./TopNavbar.vue";
import Sidebar from "@/views/components/SidebarPlugin/SideBar.vue";
import DashboardContent from "./Content.vue";
import ContentFooter from "./ContentFooter.vue";
import AppModalInfo from "@/views/components/bases/modal/AppModalInfo.vue";
import AppLoading from "@/views/components/bases/loading/AppLoading.vue";
import { ROUTE_NAME, ERROR_CODE } from "@/core/constants";
import { i18nHelper } from "@/core/utils";

export default {
  name: "Layout",
  components: {
    TopNavbar,
    Sidebar,
    DashboardContent,
    AppModalInfo,
    AppLoading,
    ContentFooter,
  },
  data: () => ({
    infoModal: {
      show: false,
      title: "",
      messages: [],
      buttons: [],
      textbox: "",
      dropbox: [],
    },
  }),
  computed: {
    ...mapGetters(["subHeader", "layoutConfig"]),
  },
  mounted() {
    if (document.getElementById("adminBody").classList.contains("d-none")) {
      this.$router.push({ name: ROUTE_NAME.HOME });
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },

    openInfoModal(title, messages, buttons, code, textbox, dropbox) {
      this.infoModal = {
        title: title,
        messages: messages,
        buttons: buttons,
        textbox: textbox,
        dropbox: dropbox,
      };

      //Error Handle by error code
      if (
        [
          ERROR_CODE.UNAUTHORIZED,
          ERROR_CODE.MULTIPLE_LOGINS,
          ERROR_CODE.INVALID_TOKEN,
        ].includes(code)
      ) {
        let newButtons = [];
        this.infoModal.title = i18nHelper.getMessage(`errorTitle.${code}`);
        // ERROR_CODE Redirect Login page without popup message
        this.$router.push({ name: ROUTE_NAME.LOGIN });

        switch (code) {
          case ERROR_CODE.UNAUTHORIZED:
            newButtons.push({
              text: i18nHelper.getMessage("label.ok"),
              variant: "primary",
              action: () => {
                this.closeInfoModal();
              },
            });
            break;
          case ERROR_CODE.MULTIPLE_LOGINS:
            newButtons.push({
              text: i18nHelper.getMessage("label.ok"),
              variant: "primary",
              action: () => {
                this.closeInfoModal();
              },
            });
            break;
          case ERROR_CODE.INVALID_TOKEN:
            newButtons.push({
              text: i18nHelper.getMessage("label.ok"),
              variant: "primary",
              action: () => {
                this.closeInfoModal();
              },
            });
            break;
        }

        this.infoModal.buttons = newButtons;
      } else {
        document.getElementById("adminBody").classList.remove("d-none");
      }

      this.infoModal.show = true;
    },
    closeInfoModal() {
      this.infoModal.show = false;
      this.infoModal.title = "";
      this.infoModal.messages = [];
      this.infoModal.buttons = [];
    },
  },
};
</script>
